import { CommitmentActivity } from "features/commitments/CommitmentActivity";
import { InvestorEntityTabProps } from "features/investor-entities/InvestorEntityTabProps";
import { useOutletContext } from "react-router-dom";

export const InvestorEntityTabActivity: React.FC = () => {
  const { investorEntityId } = useOutletContext<InvestorEntityTabProps>();
  return <CommitmentActivity investorEntityId={investorEntityId} />;
};
